<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      ok-only
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span> {{ $t("Bank receipt") }}</span>
        <span v-if="isUpdated">{{ form.tracking_number }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Type')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Type')"
                vid="type"
                rules="required"
              >
                <v-select
                  v-model="form.type"
                  :options="additionalData.types"
                  :clearable="false"
                  :reduce="_type => _type.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Bank name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank name')"
                vid="bank_name"
                rules="required"
              >
                <b-form-input
                  id="bank_name"
                  v-model="form.bank_name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Bank name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Number')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Number')"
                vid="number"
                rules="required"
              >
                <b-form-input
                  id="number"
                  v-model="form.number"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Number')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Tracking number')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Tracking number')"
                vid="tracking_number"
                rules="required"
              >
                <b-form-input
                  id="tracking_number"
                  v-model="form.tracking_number"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Tracking number')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Payment at')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Payment at')"
                vid="payment_at"
              >
                <b-form-input class="date-time-autochat" />
                <date-picker
                  v-model="form.payment_at"
                  format="YYYY-MM-DD HH:mm"
                  display-format="jYYYY/jMM/jDD HH:mm"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Payment at')"
                  type="datetime"
                  custom-input=".date-time-autochat"
                  color="#28c76f"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            v-if="$can('create','bank.receipts') || $can('update','bank.receipts')"
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Status')"
                vid="status"
                rules="required"
              >
                <v-select
                  v-model="form.status"
                  :options="additionalData.statuses"
                  :clearable="false"
                  :reduce="_status => _status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group :label="$t('Note')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Note')"
                vid="note"
              >
                <b-form-textarea
                  id="note"
                  v-model="form.note"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Note')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <attachments-form
              :form="attachmentsForm"
              :exists-attachments="form.attachments"
            />
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("Save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'
import AttachmentsForm from '../../attachments/edit/AttachmentsForm'

export default {
  name: 'BankReceiptEditModal',
  components: {
    AttachmentsForm,
  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'bank-receipts',
      modalName: 'modal-bank-receipts-edit',
      createAbleFields: [
        'type',
        'bank_name',
        'number',
        'tracking_number',
        'note',
        'status',
        'payment_at',
        'payment_id',
      ],
    }
  },
}
</script>

<style scoped>

</style>
